'use strict'

import {
	ADD_PIEZOMETER_KEY_FIGURE,
	ADD_QUALITOMETER_KEY_FIGURE,
	RECEIVE_INDUSTRIAL_SITE,
	RECEIVE_PIEZOMETER,
	RECEIVE_POLLUTED_SOIL,
	RECEIVE_QUALITOMETER,
	RECEIVE_SURFACE_QUALITOMETER,
	RESET_USER_STATION
} from '../constants/DashboardConstants'
import DtoPiezometer from '../dto/DtoPiezometer'
import DtoQualitometer from '../dto/DtoQualitometer'
import DtoPollutedSoil from '../dto/DtoPollutedSoil'
import DtoIndustrialSite from '../dto/DtoIndustrialSite'
import { isEqual, uniqWith } from 'lodash'
import DtoPiezometerKeyFigure from '../dto/DtoPiezometerKeyFigure'
import DtoQualitometerKeyFigure from '../dto/DtoQualitometerKeyFigure'

export function DashboardReducer(state = {}, action) {
	switch (action.type) {
		case RECEIVE_PIEZOMETER: {
			return Object.assign({}, state, {
				piezometers: action.piezometers.map(el => new DtoPiezometer(el)),
				userSite: uniqWith([].concat(action.piezometers.map((el) => ({ id: el.idstation })), state.userSite), isEqual)
			})
		}
		case RECEIVE_QUALITOMETER: {
			return Object.assign({}, state, {
				qualitometers: action.qualitometers.map(el => new DtoQualitometer(el)),
				userSite: uniqWith([].concat(action.qualitometers.map((el) => ({ id: el.idstation })), state.userSite), isEqual)
			})
		}
		case RECEIVE_SURFACE_QUALITOMETER: {
			return Object.assign({}, state, {
				qualitometersSurface: action.qualitometersSurface.map(el => new DtoQualitometer(el)),
				userSite: uniqWith([].concat(action.qualitometersSurface.map((el) => ({ id: el.idstation })), state.userSite), isEqual)
			})
		}
		case RECEIVE_POLLUTED_SOIL: {
			return Object.assign({}, state, {
				pollutedSoil: action.pollutedSoil.map(el => new DtoPollutedSoil(el)),
				userSite: uniqWith([].concat(action.pollutedSoil.map((el) => ({ id: el.idstation })), state.userSite), isEqual)
			})
		}
		case RECEIVE_INDUSTRIAL_SITE: {
			return Object.assign({}, state, {
				industrialSites: action.industrialSites.map(el => new DtoIndustrialSite(el)),
				userSite: uniqWith([].concat(action.industrialSites.map((el) => ({ id: el.idstation })), state.userSite), isEqual)
			})
		}
		case ADD_PIEZOMETER_KEY_FIGURE: {
			return Object.assign({}, state, {
				piezometerKeyFigures: uniqWith([].concat(action.piezometerKeyFigures.map(el => new DtoPiezometerKeyFigure(el)), state.piezometerKeyFigures), isEqual)
			})
		}
		case ADD_QUALITOMETER_KEY_FIGURE: {
			return Object.assign({}, state, {
				qualitometerKeyFigures: uniqWith([].concat(action.qualitometerKeyFigures.map(el => new DtoQualitometerKeyFigure(el)), state.qualitometerKeyFigures), isEqual)
			})
		}
		case RESET_USER_STATION: {
			return Object.assign({}, state, {
				qualitometers: [],
				piezometers: [],
				hydrometrics: [],
				pluviometers: [],
				pickupoperations: [],
				pluvioMeasures: [],
				piezometerMeasures: [],
				qualitometersSurface: [],
				hydroMeasures: [],
				pollutedSoil: [],
				industrialSites: [],
				analysis: [],
				cities: [],
				piezometerKeyFigures: [],
				qualitometerKeyFigures: [],
				userSite: []
			})
		}
		default:
			return state
	}
}

export const store = {
	qualitometers: [],
	piezometers: [],
	hydrometrics: [],
	pluviometers: [],
	pickupoperations: [],
	pluvioMeasures: [],
	piezometerMeasures: [],
	qualitometersSurface: [],
	hydroMeasures: [],
	pollutedSoil: [],
	industrialSites: [],
	analysis: [],
	piezometerKeyFigures: [],
	qualitometerKeyFigures: [],
	userSite: []
}



// WEBPACK FOOTER //
// ./src/dashboard/reducers/DashboardReducer.js